import BottomSheet from "../components/BottomSheet";
import {useEffect, useState} from "react";
import {fakePay, getOrder, swishPay, swishQR} from "../api/apis";
import QRCode from "react-qr-code";
import {useNavigate, useParams} from "react-router";
import { useApp } from "../Context";

export default function SwishModal({show, setShow, order, sum}) {
    const [qr, setQr] = useState(null)
    const [url, setUrl] = useState(null)
    const [holmesIsBetter, setHolmesIsBetter] = useState(false)
    const navigate = useNavigate();
    const {restaurant} = useParams();
    const {sid, getCfg} = useApp()
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if(show && order){
            setLoading(true)
            getCfg().then((sbo)=>{
            swishPay(order, sum,sbo).then((item)=>{
                setUrl(item.url);
                swishQR(item.token).then((result)=>{
                    setQr(result.img);
                })
               
            })
        })
        }
    }, [order, show, sum]);

    useEffect(() => {
        let intervalId;

        if (show && order) {
            intervalId = setInterval(() => {
                getOrder(order).then((item)=>{
                    if(item.order?.order00?.paid === "1"){
                        navigate(`/${restaurant}/order/${order}`);
                        navigate(0)
                    }
                })
            }, 1000);
        }

        return () => {
            clearInterval(intervalId);
        };
    }, [show, order]);


    if(!order){
        return
    }


    return(
        <BottomSheet showModal={show} setShowModal={setShow} headerText="Betala med Swish" showFooter={false}>
            <div className="d-flex flex-column align-items-center p-2 text-center">
            <p className="fs-3 fw-bold">{`Skanna ${holmesIsBetter ?"med QR-läsare" : "i Swish-appen"}`}</p>
            <div className="position-relative" style={{ background: '#f4f4f4', padding: '1.5rem', borderRadius: '1rem', boxShadow: '0 0 15px rgba(0,0,0,0.1)' }}>
            <div style={{width: "250px", height: "230px"}}>
    {
        holmesIsBetter ? (
            <div style={{
                padding: '1rem',
                background: 'white',
                borderRadius: '0.75rem',
                border: '2px dashed #e0e0e0',
                maxWidth: '240px',
                margin: 'auto'
            }}>
                <QRCode value={url} fgColor="#C5004D" size={200} />
            </div>
        ) : (
            
            <img
                src={`data:image/png;base64,${qr}`}
                alt="QR Code"
                style={{
                    borderRadius: '0.75rem',
                    maxWidth: '240px',
                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                    backgroundColor: 'white'
                }}
            />
             
        )
    }
    </div>

    <button
        className="btn btn-sm btn-outline-secondary mt-4"
        style={{margin:"auto"}}
        onClick={() => setHolmesIsBetter(!holmesIsBetter)}
    >
        {`Byt kodtyp`}
    </button>
</div>


                <hr style={{ width: '60%', borderColor: '#ccc' }} className="mt-4 mb-2"/>

                <p className="text-muted mt-0 mb-2 ">Eller betala direkt på denna enhet</p>

                <button
                    className="btn btn-warning px-4 py-2 fw-semibold"
                    onClick={() => window.location.href = url}
                >
                    Öppna i Swish
                </button>
                {/*sid === "S0009999" && 
                    <button className="btn btn-secondary mt-2"
                        onClick={()=>{fakePay(order)}}
                        >
                        Markera som betald
                    </button>*/}
            </div>
        </BottomSheet>

    )
}